var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceModel1Rect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 100",
    width: 200,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 200,
    height: 100,
    rx: 15,
    fill: "#D2DAE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceModel1Rect);
export default __webpack_public_path__ + "static/media/place_model-1_rect.91409037c547e5c607dcb5fb61fbedd7.svg";
export { ForwardRef as ReactComponent };